"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

exports.__esModule = true;

var react_1 = __importStar(require("react"));

var dropdown_1 = require("../../atoms/dropdown");

var input_1 = require("../../atoms/input");

var nama_icon_1 = require("../../atoms/nama-icon");

var date_fns_1 = require("date-fns");

require("./date-range-picker.scss");

;
var defaultRanges = {
  'today': {
    from: date_fns_1.startOfToday(),
    to: date_fns_1.endOfToday()
  },
  'yesterday': {
    from: date_fns_1.startOfYesterday(),
    to: date_fns_1.endOfYesterday()
  },
  'last7': {
    from: date_fns_1.subDays(date_fns_1.startOfToday(), 7),
    to: date_fns_1.endOfToday()
  },
  'last30': {
    from: date_fns_1.subDays(date_fns_1.startOfToday(), 30),
    to: date_fns_1.endOfToday()
  },
  'last90': {
    from: date_fns_1.subDays(date_fns_1.startOfToday(), 90),
    to: date_fns_1.endOfToday()
  },
  'currentYear': {
    from: date_fns_1.startOfYear(date_fns_1.startOfToday()),
    to: date_fns_1.endOfToday()
  }
};

var DateRangePicker = function DateRangePicker(_a) {
  var dateRange = _a.dateRange,
      onSelect = _a.onSelect;

  var _b = react_1.useState('today'),
      selectedValue = _b[0],
      setSelectedValue = _b[1];

  var _c = react_1.useState(''),
      tempFrom = _c[0],
      setTempFrom = _c[1];

  var _d = react_1.useState(''),
      tempTo = _d[0],
      setTempTo = _d[1];

  react_1.useEffect(function () {
    setTempFrom(date_fns_1.format(dateRange.from, 'dd/LL/yyyy'));
    setTempTo(date_fns_1.format(dateRange.to, 'dd/LL/yyyy'));
    setSelectedValue(matchRangeItem(dateRange));
  }, [dateRange]);

  var matchRangeItem = function matchRangeItem(range) {
    for (var defaulRange in defaultRanges) {
      if (date_fns_1.isSameDay(defaultRanges[defaulRange].from, range.from) && date_fns_1.isSameDay(defaultRanges[defaulRange].to, range.to)) return defaulRange;
    }

    return 'custom';
  };

  var handleRangeSelect = function handleRangeSelect(selected) {
    if (selected.value === 'custom') return;
    onSelect(defaultRanges[selected.value]);
    setSelectedValue(selected.value);
  };

  var handleBlurDateInput = function handleBlurDateInput() {
    if (tempFrom && tempTo) {
      var fromDate = date_fns_1.parse(tempFrom, 'dd/LL/yyyy', dateRange.from);
      var toDate = date_fns_1.parse(tempTo, 'dd/LL/yyyy', dateRange.to);
      var minDate = new Date(2018, 0, 1, 0, 0, 0, 0);

      if (Boolean(+fromDate) && Boolean(+toDate)) {
        if (date_fns_1.isBefore(fromDate, minDate)) fromDate = minDate;
        if (date_fns_1.isBefore(toDate, minDate)) toDate = minDate;
        if (date_fns_1.isAfter(toDate, date_fns_1.endOfToday())) toDate = date_fns_1.endOfToday();
        if (date_fns_1.isAfter(fromDate, toDate)) fromDate = date_fns_1.startOfDay(toDate);
        var newRange = {
          from: date_fns_1.startOfDay(fromDate),
          to: date_fns_1.endOfDay(toDate)
        };
        onSelect(newRange);
      } else {
        setTempFrom(date_fns_1.format(dateRange.from, 'dd/LL/yyyy'));
        setTempTo(date_fns_1.format(dateRange.to, 'dd/LL/yyyy'));
      }
    }
  };

  var Trigger = react_1["default"].createElement("div", {
    className: 'nama-date-range-picker'
  }, react_1["default"].createElement(nama_icon_1.NamaIcon, {
    icon: 'Calendar',
    className: 'fill-grey-700'
  }), react_1["default"].createElement("span", null, "de"), react_1["default"].createElement(input_1.Input, {
    type: 'text',
    onClick: function onClick(e) {
      return e.preventDefault;
    },
    mask: '99/99/9999',
    value: tempFrom,
    getRef: function getRef(ref) {
      if (ref) ref.onblur = handleBlurDateInput;
    },
    onChange: function onChange(e) {
      return setTempFrom(e.target.value);
    },
    hideBorders: true,
    inputSize: input_1.InputSizes.small
  }), react_1["default"].createElement("span", null, "at\xE9"), react_1["default"].createElement(input_1.Input, {
    type: 'text',
    onClick: function onClick(e) {
      return e.stopPropagation;
    },
    mask: '99/99/9999',
    value: tempTo,
    hideBorders: true,
    getRef: function getRef(ref) {
      if (ref) ref.onblur = handleBlurDateInput;
    },
    onChange: function onChange(e) {
      return setTempTo(e.target.value);
    },
    inputSize: input_1.InputSizes.small
  }));
  var items = [{
    label: 'Hoje',
    value: 'today'
  }, {
    label: 'Ontem',
    value: 'yesterday'
  }, {
    label: 'Últimos 7 dias',
    value: 'last7'
  }, {
    label: 'Últimos 30 dias',
    value: 'last30'
  }, {
    label: 'Últimos 90 dias',
    value: 'last90'
  }, {
    label: 'Desde o início do ano',
    value: 'currentYear'
  }];

  if (selectedValue === 'custom') {
    items.push({
      value: 'divider'
    });
    items.push({
      label: 'Período customizado',
      value: 'custom'
    });
  }

  return react_1["default"].createElement(dropdown_1.Dropdown, {
    items: items,
    selected: {
      value: selectedValue
    },
    trigger: Trigger,
    triggerAction: dropdown_1.triggerActions.open,
    onSelect: handleRangeSelect,
    className: "date-range-picker"
  });
};

exports.DateRangePicker = DateRangePicker;